import styled from "styled-components";

export const RemoveButton = styled.div<{isMobile?: boolean, disabled?: boolean}>`
    margin-top: ${props=>!props.isMobile? '65px':''};
    width: ${props=>props.isMobile? '5%':''};
    margin-left: ${props=>props.isMobile? '50%':''};
    margin-top: ${props=>props.isMobile? '12px':''};
    cursor: ${props=>props.disabled? 'auto':'pointer'};
`